<div class="difficulty-tabs-wrapper">
  <label class="difficulty-label">Difficulty Level*</label>
  <div class="difficulty-tabs">
    <button (click)="setDifficulty(_DifficultyType.Easy)" [class.active]="selected === _DifficultyType.Easy">Easy</button>
    <button (click)="setDifficulty(_DifficultyType.Medium)" [class.active]="selected === _DifficultyType.Medium">Medium</button>
    <button (click)="setDifficulty(_DifficultyType.Hard)" [class.active]="selected === _DifficultyType.Hard">Hard</button>
  </div>
</div>